::ng-deep particle-dashboard-hitmap iframe{border:0}
/*# sourceMappingURL=dashboard-content.component-LIVVOMML.css.map */
